/**
 * @file API SDK client with typed configuration for the Mosaic API.
 *
 * Uses openapi-fetch to provide type-safe API calls based on the generated OpenAPI types.
 */ import createClient from "openapi-fetch";
/**
 * Create a typed API SDK client for the Mosaic API.
 *
 * @param options - Configuration options for the SDK client.
 * @returns A typed API client instance.
 *
 * @example
 * ```typescript
 * const client = createApiSdk({ baseUrl: 'http://localhost:3000' });
 * const { data } = await client.GET('/api/~/ping');
 * console.log(data?.pong); // 'pong'
 * ```
 */ export const createApiSdk = createClient;

//# sourceMappingURL=sdk.js.map